module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "web-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2019高考真题在线估分")]), _vm._v(" "), _c('div', {
    staticClass: "estimate-num"
  }, _vm._l((_vm.numbers), function(n) {
    return _c('span', [_vm._v(_vm._s(n))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("在线估分考生人数")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "copyright",
    on: {
      "click": function($event) {
        return _vm.gotoUrl()
      }
    }
  }, [_vm._v("北京贞观雨科技有限公司版权所有 关于我们")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "web-logo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ercode"
  }, [_c('p', [_vm._v("扫码闪电估分")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "114",
      "height": "114",
      "src": "//gallery.fbcontent.cn/api/ape/images/15bfc571794b116.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2c15624"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebPage.vue
// module id = 477
// module chunks = 1